"use client";

export interface SerializedFunnelData {
  contractId?: string | null;
  contractToken?: string | null;
  offerAgentId?: string | null;
  petType?: "cat" | "dog" | null;
  petName?: string | null;
  breed?: string | null;
  breedLabel?: string | null;
  birthDate?: string | null;
  selectedBreedType?: "purebred" | "crossbreed" | "mixed" | null;
  gender?: "male" | "female" | "unknown" | null;
  isCastrated?: boolean;
  isHouseCat?: boolean;
  selectedDogSize?: "small" | "large" | null;
  chipNumber?: string | null;
  bundlePrices?: { S: number; M: number; L: number } | null;
  selectedProductId?: "s" | "m" | "l" | null;
  finalPrice?: number | null;
  contactName?: string | null; // Keep for backward compatibility during hydration
  contactFirstName?: string | null;
  contactLastName?: string | null;
  contactEmail?: string | null;
  contactPhone?: string | null;
  street?: string | null;
  housenumber?: string | null;
  city?: string | null;
  zipCode?: string | null;
  country?: string | null;
  contactBirthdate?: string | null;
  customerGender?: "male" | "female" | null;
  preexistingCoverage?: boolean;
  worldwideCoverage?: boolean;
  yearlyDeductible?: number;
  coPayCoveragePercentage?: number;
  paymentInterval?: 1 | 2 | 4 | 12;
  paymentMethod?: "credit_card" | "ESR";
  startOfInsurance?: string | null;
  firstDue?: string | null;
  isOfferLoadingFromUrl?: boolean;
  dispatchContract?: "customer" | "customer_and_agent" | "agent";
  dispatchInvoice?: "customer" | "customer_and_agent" | "agent";
  dispatchReminder?: "customer" | "customer_and_agent" | "agent";
  dispatchEmail?: "customer" | "customer_and_agent" | "agent";
  agentDispatchEmail?: string | null;
  agentId?: string | null;
  whitelabelPartner?: string | null;
  offerLoadedFromUrl?: boolean;
  hasLeftConfirmationAfterOfferLoad?: boolean;
  consultationProtocolDocumentId?: number | null;
  consultationProtocolFilename?: string | null;
  consultationProtocolPendingFile?: string | null;
  consultationProtocolPendingFilename?: string | null;
}

export const isLocalStorageAvailable = () => {
  if (typeof window === "undefined") return false;
  try {
    const storage = window.localStorage;
    const testKey = "__funnel_storage_test__";
    storage.setItem(testKey, "1");
    storage.removeItem(testKey);
    return true;
  } catch {
    return false;
  }
};

export const loadFunnelFromStorage = (storageKey: string): SerializedFunnelData | null => {
  if (!isLocalStorageAvailable()) return null;
  const raw = localStorage.getItem(storageKey);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as SerializedFunnelData;
  } catch (error) {
    console.warn(`Failed to parse stored funnel data for key '${storageKey}', clearing corrupted entry.`, error);
    localStorage.removeItem(storageKey);
    return null;
  }
};

export const saveFunnelToStorage = (storageKey: string, data: SerializedFunnelData) => {
  if (!isLocalStorageAvailable()) return;
  localStorage.setItem(storageKey, JSON.stringify(data));
};
